import { render } from "./TrainStation.vue?vue&type=template&id=bad60b2c"
import script from "./TrainStation.vue?vue&type=script&lang=js"
export * from "./TrainStation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__